export default "__VITE_ASSET__ScbIbR5t__"